export const SUCCESS_RESPONSE_TYPE = 'success'
